<template>
    <div>
        <div class='d-flex align-items-center justify-content-between neue' :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <Icon v-if="this.isMobile" name="arrow-left" size="c24" class="pointer" @click="this.close" />
            <h4 class="text-black fsp20 neue mb-0 lh28" :class="{'text-center flex-grow-1 mr24': this.isMobile}">{{ this.isMobile ? this.$t('views.ChoiseKeyt.3') : this.content.title }}</h4>
            <Icon v-if="!this.isMobile" name="close" size="c24" class="pointer" @click="this.close" />
        </div>
        <div class="bg-white rounded12" :class="{ 'p24': !this.isMobile }">
            <div class="keyts-wrapper">
                <div class="neue-roman text-black fsp14 mb8">{{ $t('views.ChoiseKeyt.2') }}</div>
                <SelectSimple
                    label="Счёт"
                    id="keyt"
                    :dataValue="this.keyt"
                    @updateParentState="this.updateState" 
                    :keywords.sync="this.content.keyts"
                    :keyt="true"
                    :isSearch="true"
                />
            </div>
            <div 
                class="mt-4 m-auto d-flex align-items-center justify-content-between"
                :class="{ 'position-fixed px24 py16 start-0 bottom-0 bg-white w-100 border-t': this.isMobile }"
            >
                <Button
                    :name="this.$t('views.ATM.12')"
                    class="equal-width h48 mr16"
                    type='btn-warning'
                    @click="this.setKeyt()"
                />
                <Button
                    :name="this.$t('views.ATM.11')"
                    class="equal-width h48"
                    type='btn-outline-warning'
                    @click="this.close"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputsRadioGroups from '@/components/service/InputsRadioGroups';
import SelectSimple from '@/components/service/SelectSimple';
import Icon from '@/components/icons/Icon';

export default {
    components: {
        Button,
        InputsRadioGroups,
        SelectSimple,
        Icon
    },
    props: {
        close: [Function],
    },
    data () {
        return {
            content: this.$store.state.modal.content,
            keyt: false,
        }
    },
    methods: {
        updateState(arg) {
            this.keyt = arg.value;
        },
        setKeyt() {
            this.content.updateKeyt(this.keyt);
            this.close();
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    created() {
        console.log('created this.content.keyts', this.content.keyts);
        console.log('store userKeyts', this.$store.state.userData.keyts);
    }
}
</script>

